import { useLanguageContext } from "../context/LanguageContext";

const Boards = () => {
  const { isHE } = useLanguageContext();

    return (
      <div 
      className="p-4 bg-terminal min-h-screen" 
      dir={isHE ? "rtl" : "ltr"}
      >
        <h1 className="text-3xl font-bold">
          {isHE ? "הביג בורד של מומחי הדראפט" : "Draft Gurus Board"
          }
        </h1>
        <p className="mt-5 w-2/3 text-center mx-auto">
          {
            isHE ? 
            "הדף נמצא כעת בתהליכי בנייה, אך יכלול דירוגי רי-דראפט ממחזורים שונים מהעבר, ועל בסיס דירוגים אלו, דירוג ייחודי של מומחי דראפט מכל רחבי האינטרנט, בהתבסס על הביג בורדים העדכניים ביותר שלהם." : 
            "Page is currently under construction, but will include re-draft rankings from various past drafts, and based on these rankings, a unique ranking of NBA Draft experts from around the web, based on their most recent big boards."
          }
        </p>
      </div>
    );
  };
  
  export default Boards;
  